import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  createWebsiteMetaDataAPI,
  deleteWebsiteMetaDataAPI,
  deleteWebsiteMetaDataIconAPI,
  getAllWebsiteMetaDataAPI,
  getWebsiteMetaDataAPI,
  updateWebsiteMetaDataAPI,
  uploadWebsiteMetaDataIconAPI,
} from "../../api/common/WebsiteMetaDataApi";

const initialState = {
  websiteMetaData: {},
  websiteMetaDataList: [],
  uploadedIcon: null,
  loading: false,
  addUpdateLoading: null,
  iconLoading: null,
};

export const getWebsiteMetaData = createAsyncThunk(
  "websiteMetaData/getWebsiteMetaData",
  async (websiteId, { rejectWithValue }) => {
    try {
      const response = await getWebsiteMetaDataAPI(websiteId);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const getAllWebsiteMetaData = createAsyncThunk(
  "websiteMetaData/getAllWebsiteMetaData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAllWebsiteMetaDataAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const createWebsiteMetaData = createAsyncThunk(
  "websiteMetaData/createWebsiteMetaData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createWebsiteMetaDataAPI(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const updateWebsiteMetaData = createAsyncThunk(
  "websiteMetaData/updateWebsiteMetaData",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateWebsiteMetaDataAPI(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const deleteWebsiteMetaData = createAsyncThunk(
  "websiteMetaData/deleteWebsiteMetaData",
  async (id, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteMetaDataAPI(id);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const uploadWebsiteMetaDataIcon = createAsyncThunk(
  "websiteMetaData/uploadWebsiteMetaDataIcon",
  async (file, { rejectWithValue }) => {
    try {
      const response = await uploadWebsiteMetaDataIconAPI(file);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

export const deleteWebsiteMetaDataIcon = createAsyncThunk(
  "websiteMetaData/deleteWebsiteMetaDataIcon",
  async (uploadId, { rejectWithValue }) => {
    try {
      const response = await deleteWebsiteMetaDataIconAPI(uploadId);
      return response.data;
    } catch (error) {
      return rejectWithValue({
        errorMessage: error?.message,
      });
    }
  },
);

const websiteMetaDataSlice = createSlice({
  name: "websiteMetaData",
  initialState,
  reducers: {
    clearWebsiteMetaDataIcon: (state) => {
      state.uploadedIcon = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getWebsiteMetaData.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getWebsiteMetaData.fulfilled, (state, action) => {
      state.websiteMetaData = action?.payload?.response;
      state.loading = true;
    });
    builder.addCase(getWebsiteMetaData.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(getAllWebsiteMetaData.pending, (state) => {
      state.loading = false;
    });
    builder.addCase(getAllWebsiteMetaData.fulfilled, (state, action) => {
      state.websiteMetaDataList = action?.payload?.response;
      state.loading = true;
    });
    builder.addCase(getAllWebsiteMetaData.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(createWebsiteMetaData.pending, (state) => {
      state.addUpdateLoading = false;
    });
    builder.addCase(createWebsiteMetaData.fulfilled, (state, action) => {
      state.websiteMetaData = action?.payload?.response;
      state.addUpdateLoading = true;
    });
    builder.addCase(createWebsiteMetaData.rejected, (state) => {
      state.addUpdateLoading = null;
    });

    builder.addCase(updateWebsiteMetaData.pending, (state) => {
      state.addUpdateLoading = false;
    });
    builder.addCase(updateWebsiteMetaData.fulfilled, (state, action) => {
      state.websiteMetaData = action?.payload?.response;
      state.addUpdateLoading = true;
    });
    builder.addCase(updateWebsiteMetaData.rejected, (state) => {
      state.addUpdateLoading = null;
    });

    builder.addCase(deleteWebsiteMetaData.pending, (state) => {
      state.addUpdateLoading = false;
    });
    builder.addCase(deleteWebsiteMetaData.fulfilled, (state) => {
      state.websiteMetaData = {};
      state.addUpdateLoading = true;
    });
    builder.addCase(deleteWebsiteMetaData.rejected, (state) => {
      state.addUpdateLoading = null;
    });

    builder.addCase(uploadWebsiteMetaDataIcon.pending, (state) => {
      state.iconLoading = false;
    });
    builder.addCase(uploadWebsiteMetaDataIcon.fulfilled, (state, action) => {
      state.uploadedIcon = action?.payload?.response;
      state.iconLoading = true;
    });
    builder.addCase(uploadWebsiteMetaDataIcon.rejected, (state) => {
      state.iconLoading = null;
    });

    builder.addCase(deleteWebsiteMetaDataIcon.pending, (state) => {
      state.iconLoading = false;
    });
    builder.addCase(deleteWebsiteMetaDataIcon.fulfilled, (state) => {
      state.uploadedIcon = null;
      state.iconLoading = true;
    });
    builder.addCase(deleteWebsiteMetaDataIcon.rejected, (state) => {
      state.iconLoading = null;
    });
  },
});

export const { clearWebsiteMetaDataIcon } = websiteMetaDataSlice.actions;
export default websiteMetaDataSlice.reducer;
